import { platformBrowserDynamic } from '@angular/platform-browser-dynamic'
import { enableProdMode } from '@angular/core'
import { AppModule } from './app/app.module'

// Styles.
// Enables Hot Module Replacement.
declare var module: any

if (module.hot) {
    module.hot.accept()
}

//if (process.env.ENV === 'localhost') {
//enableProdMode()
//}

// Enable production mode unless running locally
if (!/localhost/.test(document.location.host)) {
    enableProdMode();
}

platformBrowserDynamic().bootstrapModule(AppModule)
